// wrapper to call Live's REST endpoints, structure based on the generated service/client code in `api.ts`

import { HttpClient, RestResponse } from './api'

export interface LiveHttpServices {
    deletePlugin(id: number): RestResponse<any>
}

export class LiveHttpServicesClient implements LiveHttpServices {
    private httpClient: HttpClient
    constructor(httpClient: HttpClient) {
        this.httpClient = httpClient
    }

    deletePlugin(id: number): RestResponse<any> {
        return this.httpClient.request({ method: 'DELETE', url: `plugin/${id}` })
    }
}
